
import { Mail, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";

interface UserHeaderProps {
  userEmail: string;
  onSignOut: () => void;
}

const UserHeader = ({ userEmail, onSignOut }: UserHeaderProps) => {
  return (
    <div className="mb-6 flex items-center justify-center gap-2 text-sm text-gray-600">
      <Mail className="w-4 h-4" />
      <span>{userEmail}</span>
      <Button
        variant="ghost"
        size="sm"
        onClick={onSignOut}
        className="text-gray-500 hover:text-gray-700"
      >
        <LogOut className="w-4 h-4" />
      </Button>
    </div>
  );
};

export default UserHeader;
